import questions from 'data/questions'

const defaultState = {
  items: [],
  currentQuestionIndex: 0,
  currentAnswer: null,
  currentResult: null,
}

export default {
  namespace: 'question',
  state: Object.assign({}, defaultState),
  subscriptions: {
    setup({ dispatch }) {
      dispatch({ type: 'setItems', payload: questions })
    },
  },
  reducers: {
    setItems(state, { payload }) {
      return Object.assign({}, state, {
        items: payload
      })
    },
    setResult(state, { payload }) {
      return Object.assign({}, state, {
        currentResult: Object.assign({}, state.currentResult, payload)
      })
    },
    setAnswer(state, { payload }) {
      return Object.assign({}, state, {
        currentAnswer: Object.assign({}, state.currentAnswer, payload)
      })
    },
    goToNext(state) {
      return Object.assign({}, state, {
        currentQuestionIndex: state.currentQuestionIndex + 1,
        currentResult: null,
        currentAnswer: null,
      })
    },
    reset() {
      return Object.assign({}, defaultState, {
        items: questions
      })
    }
  },
}


// WEBPACK FOOTER //
// ./src/models/question/index.js